/**
 *
 * MobileHotelSearchCompact
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cs from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import * as COLORS from 'Constants/colors';
import { ReactComponent as Edit } from './Edit.svg';
import Icon from 'Components/Icon';
import Text from 'Components/Text';
import { formatShort } from 'Utils/dates';
import { totalPeople, setDetailMode } from 'Features/hotels';

const selector = ({ hotels }) => ({
  checkIn: hotels.search.checkIn,
  checkOut: hotels.search.checkOut,
  location: hotels.search.location,
  roomInformation: hotels.search.roomInformation
});

const ConnectedMobileHotelSearchCompact = props => {
  const dispatch = useDispatch();
  const actions = {
    setModify: () => {
      dispatch(setDetailMode(false));
    }
  };

  const state = useSelector(selector);

  return (
    <StyledMobileHotelSearchCompact actions={actions} {...state} {...props} />
  );
};

const MobileHotelSearchCompact = ({
  className,
  checkIn,
  checkOut,
  location,
  roomInformation,
  actions
}) => (
  <div className={cs(className)}>
    <div className="destination-container">
      <div className="flex-row">
        <div className="flex-row noWrap">
          <Icon name="mv-location-2" size={20} />
          <NewText weight="semi-bold" noWrap>
            {location.description}
          </NewText>
        </div>
      </div>
      <div className="flex-row">
        <Icon name="mv-calendar" size={20} />
        <NewText weight="semi-bold">
          {formatShort(checkIn)} - {formatShort(checkOut)}
        </NewText>
        <div className="flex-row margin-left">
          <Icon name="mv-bed-double" size={20} />
          <NewText weight="semi-bold">{roomInformation.length}</NewText>
        </div>
        <div className="flex-row margin-left">
          <Icon name="mv-user" size={20} />
          <Text weight="semi-bold">{totalPeople(roomInformation)}</Text>
        </div>
      </div>
    </div>
    <div className="search-container" onClick={actions.setModify}>
      <Edit />
    </div>
  </div>
);

MobileHotelSearchCompact.propTypes = {
  className: PropTypes.string.isRequired,
  checkIn: PropTypes.string,
  checkOut: PropTypes.string,
  roomInformation: PropTypes.array,
  location: PropTypes.shape({
    placeId: PropTypes.string,
    description: PropTypes.string
  }),
  actions: PropTypes.shape({
    setModify: PropTypes.func.isRequired
  })
};

const StyledMobileHotelSearchCompact = styled(MobileHotelSearchCompact)`
  display: flex;
  justify-content: space-between;
  padding: 5px 15px 5px 15px;
  background: ${COLORS.white};
  width: 100%;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

  .search-container {
    color: ${COLORS.important};
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 25px;
      margin-right: 10px;
      color: ${COLORS.important};
    }
  }

  .destination-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;

    .flex-row {
      display: flex;
      align-items: center;
      margin-top: 4px;
      margin-bottom: 4px;

      .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 7px;
        color: ${COLORS.important};
      }
    }
  }

  .margin-left {
    margin-left: 15px;
    margin-right: 5px;
  }
`;

const NewText = styled.span`
  color: #282828;
  font-family: Itau Display Pro;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`;

export default ConnectedMobileHotelSearchCompact;
export { StyledMobileHotelSearchCompact as MobileHotelSearchCompact };
